// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contract-page {
  max-width: 800px;
  margin: 0 auto;
}

.contract-header {
  text-align: center;
  margin-bottom: 32px;
}

.contract-header h2 {
  margin: 0 0 12px 0;
  color: #333;
  font-size: 28px;
  font-weight: 700;
}

.contract-intro {
  color: #666;
  font-size: 15px;
  margin: 0 0 16px 0;
}

.contract-meta {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
}

.contract-company {
  font-weight: 600;
  color: #333;
  font-size: 16px;
}

.contract-version {
  color: #666;
  font-size: 14px;
}

.contract-content {
  max-height: 400px;
  overflow-y: auto;
  padding: 24px;
  background: #f8f9fa;
  border-radius: 12px;
  margin-bottom: 32px;
  border: 1px solid #e0e0e0;
}

.contract-text {
  color: #333;
  font-size: 14px;
  line-height: 1.8;
}

.contract-text h1,
.contract-text h2,
.contract-text h3 {
  color: #333;
  margin-top: 24px;
  margin-bottom: 12px;
}

.contract-text h1 {
  font-size: 24px;
}

.contract-text h2 {
  font-size: 20px;
}

.contract-text h3 {
  font-size: 18px;
}

.contract-text p {
  margin-bottom: 12px;
}

.contract-text ul,
.contract-text ol {
  margin-left: 24px;
  margin-bottom: 12px;
}

.contract-text li {
  margin-bottom: 8px;
}

.contract-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.form-group input {
  padding: 14px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
  background: #fafafa;
}

.form-group input:focus {
  outline: none;
  border-color: #667eea;
  background: white;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.accept-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 8px;
  transition: background 0.3s ease;
}

.accept-checkbox:hover {
  background: #e9ecef;
}

.accept-checkbox input[type="checkbox"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-top: 2px;
  flex-shrink: 0;
}

.accept-checkbox span {
  color: #333;
  font-size: 14px;
  line-height: 1.5;
  font-weight: 500;
}

.sign-button {
  padding: 16px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sign-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

.sign-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  padding: 12px;
  background: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 8px;
  color: #e74c3c;
  font-size: 14px;
  text-align: center;
}

.loading-spinner,
.error-state {
  text-align: center;
  padding: 40px;
}

.spinner {
  border: 4px solid rgba(102, 126, 234, 0.1);
  border-top-color: #667eea;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.retry-button {
  padding: 12px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 16px;
  transition: all 0.3s ease;
}

.retry-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
}

`, "",{"version":3,"sources":["webpack://./src/components/onboarding/ContractPage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD","sourcesContent":[".contract-page {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.contract-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.contract-header h2 {\n  margin: 0 0 12px 0;\n  color: #333;\n  font-size: 28px;\n  font-weight: 700;\n}\n\n.contract-intro {\n  color: #666;\n  font-size: 15px;\n  margin: 0 0 16px 0;\n}\n\n.contract-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 16px;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.contract-company {\n  font-weight: 600;\n  color: #333;\n  font-size: 16px;\n}\n\n.contract-version {\n  color: #666;\n  font-size: 14px;\n}\n\n.contract-content {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 24px;\n  background: #f8f9fa;\n  border-radius: 12px;\n  margin-bottom: 32px;\n  border: 1px solid #e0e0e0;\n}\n\n.contract-text {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.8;\n}\n\n.contract-text h1,\n.contract-text h2,\n.contract-text h3 {\n  color: #333;\n  margin-top: 24px;\n  margin-bottom: 12px;\n}\n\n.contract-text h1 {\n  font-size: 24px;\n}\n\n.contract-text h2 {\n  font-size: 20px;\n}\n\n.contract-text h3 {\n  font-size: 18px;\n}\n\n.contract-text p {\n  margin-bottom: 12px;\n}\n\n.contract-text ul,\n.contract-text ol {\n  margin-left: 24px;\n  margin-bottom: 12px;\n}\n\n.contract-text li {\n  margin-bottom: 8px;\n}\n\n.contract-form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group label {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n}\n\n.form-group input {\n  padding: 14px 16px;\n  border: 2px solid #e0e0e0;\n  border-radius: 8px;\n  font-size: 15px;\n  transition: all 0.3s ease;\n  background: #fafafa;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #667eea;\n  background: white;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n}\n\n.accept-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  cursor: pointer;\n  padding: 16px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  transition: background 0.3s ease;\n}\n\n.accept-checkbox:hover {\n  background: #e9ecef;\n}\n\n.accept-checkbox input[type=\"checkbox\"] {\n  width: 20px;\n  height: 20px;\n  cursor: pointer;\n  margin-top: 2px;\n  flex-shrink: 0;\n}\n\n.accept-checkbox span {\n  color: #333;\n  font-size: 14px;\n  line-height: 1.5;\n  font-weight: 500;\n}\n\n.sign-button {\n  padding: 16px 32px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sign-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n.sign-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.error-message {\n  padding: 12px;\n  background: #fff5f5;\n  border: 1px solid #feb2b2;\n  border-radius: 8px;\n  color: #e74c3c;\n  font-size: 14px;\n  text-align: center;\n}\n\n.loading-spinner,\n.error-state {\n  text-align: center;\n  padding: 40px;\n}\n\n.spinner {\n  border: 4px solid rgba(102, 126, 234, 0.1);\n  border-top-color: #667eea;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  animation: spin 0.8s linear infinite;\n  margin: 0 auto 20px;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.retry-button {\n  padding: 12px 24px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  margin-top: 16px;\n  transition: all 0.3s ease;\n}\n\n.retry-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
